
import { Vue, Component, Ref } from 'vue-property-decorator';
import { BrandService } from '@/services/brand_service';
import lazyInject from '@/di';
import { v4 } from 'uuid';
import { component as Viewer } from 'v-viewer';
import VideoUModal from '@/components/video/VideoModal.vue';

@Component({
  components: {
    Viewer,
    VideoUModal,
  },
})
export default class LogDetailDrawer extends Vue {
  visible = false;

  @lazyInject(BrandService)
  protected brandService!: BrandService;

  @Ref('videoUModal')
  videoUModal!: VideoUModal;

  wordTitleArray: any = [
    { title: '环境', id: '', type: 'env' },
    { title: '产品服务', id: '', type: 'product_service' },
    { title: '其他', id: '', type: 'other' },
    { title: '店内环境', id: '', type: 'inner_env' },
  ];


  logObj: any = {};

  dictionaryObject: any = {
    env: '环境',
    product_service: '产品服务',
    other: '其他',
    inner_env: '店内环境',
    video: '视频',
    header: '头图',
    shops: '适用门店',
    template_name: '模版名称',
    cover: '封面图',
    new: '新模版名称',
    old: '原模版名称',
    add: '本次新增',
    delete: '本次删除',
  };

  uuid = v4;

  async init(val: any) {
    this.visible = true;
    const params = {
      log_id: val.id,
    };
    const res = await this.brandService.brandAlbumKaTemplateLogDetail(params);
    this.logObj = res;
    Object.entries(res).forEach(([key, value]) => {
      console.log(key, value);
    });
  }

  close() {
    this.visible = false;
  }

  extractAddDelete(obj: Record<string, any>): { add?: any[]; delete?: any[] } {
    const add = Array.isArray(obj.add) ? obj.add : [];

    const del = Array.isArray(obj.delete) ? obj.delete : [];

    const result: any = { add, delete: del };

    if (add.length === 0) {
      delete result.add;
    }

    if (del.length === 0) {
      delete result.delete;
    }

    return result;
  }
  removeEmptyHeader<T extends Record<string, any>>(obj: T): Omit<T, 'header'> | T {
    const { header, ...rest } = obj;

    if (Array.isArray(header) && header.length === 0) {
      return rest as Omit<T, 'header'>;
    }

    return obj;
  }

  playVideo(res: any) {
    this.videoUModal.open(res.url);
  }
}
